module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0105.jpg?v=8645a5a6";